<template>
    <div class="notFound">
        <h1>404 你使用的不是Chrome最新版浏览器</h1>
        <p class="zoom-area">请下载最新版Chrome浏览器</p>
        <section class="error-container">
            <span>4</span>
            <span><span class="screen-reader-text">0</span></span>
            <span>4</span>
        </section>
        <div class="link-container">
            <a
                target="_blank"
                href="https://tubusi01.oss-cn-beijing.aliyuncs.com/app/windows.zip"
                class="more-link"
                >点击下载最新Chrome浏览器(window版)</a
            >
            <a
                target="_blank"
                href="https://tubusi01.oss-cn-beijing.aliyuncs.com/app/mac.zip"
                class="more-link"
                >点击下载最新Chrome浏览器(mac版)</a
            >
        </div>
    </div>
</template>

<script setup></script>

<style lang="less" scoped>
.notFound {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #416475;
    z-index: 20200000000;
    display: flex;
    flex-direction: column;
    justify-content: center;
}
</style>
<style scoped>
@import url('https://fonts.googleapis.com/css?family=Montserrat:400,600,700');
@import url('https://fonts.googleapis.com/css?family=Catamaran:400,800');
.error-container {
    text-align: center;
    font-size: 180px;
    font-family: 'Catamaran', sans-serif;
    font-weight: 800;
    margin: 20px 15px;
}
.error-container > span {
    display: inline-block;
    line-height: 0.7;
    position: relative;
    color: #ffb485;
}
.error-container > span {
    display: inline-block;
    position: relative;
    vertical-align: middle;
}
.error-container > span:nth-of-type(1) {
    color: #d1f2a5;
    animation: colordancing 4s infinite;
}
.error-container > span:nth-of-type(3) {
    color: #f56991;
    animation: colordancing2 4s infinite;
}
.error-container > span:nth-of-type(2) {
    width: 120px;
    height: 120px;
    border-radius: 999px;
}
.error-container > span:nth-of-type(2):before,
.error-container > span:nth-of-type(2):after {
    border-radius: 0%;
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: inherit;
    height: inherit;
    border-radius: 999px;
    box-shadow: inset 30px 0 0 rgba(209, 242, 165, 0.4),
        inset 0 30px 0 rgba(239, 250, 180, 0.4),
        inset -30px 0 0 rgba(255, 196, 140, 0.4),
        inset 0 -30px 0 rgba(245, 105, 145, 0.4);
    animation: shadowsdancing 4s infinite;
}
.error-container > span:nth-of-type(2):before {
    -webkit-transform: rotate(45deg);
    -moz-transform: rotate(45deg);
    transform: rotate(45deg);
}

.screen-reader-text {
    position: absolute;
    top: -9999em;
    left: -9999em;
}
@keyframes shadowsdancing {
    0% {
        box-shadow: inset 30px 0 0 rgba(209, 242, 165, 0.4),
            inset 0 30px 0 rgba(239, 250, 180, 0.4),
            inset -30px 0 0 rgba(255, 196, 140, 0.4),
            inset 0 -30px 0 rgba(245, 105, 145, 0.4);
    }
    25% {
        box-shadow: inset 30px 0 0 rgba(245, 105, 145, 0.4),
            inset 0 30px 0 rgba(209, 242, 165, 0.4),
            inset -30px 0 0 rgba(239, 250, 180, 0.4),
            inset 0 -30px 0 rgba(255, 196, 140, 0.4);
    }
    50% {
        box-shadow: inset 30px 0 0 rgba(255, 196, 140, 0.4),
            inset 0 30px 0 rgba(245, 105, 145, 0.4),
            inset -30px 0 0 rgba(209, 242, 165, 0.4),
            inset 0 -30px 0 rgba(239, 250, 180, 0.4);
    }
    75% {
        box-shadow: inset 30px 0 0 rgba(239, 250, 180, 0.4),
            inset 0 30px 0 rgba(255, 196, 140, 0.4),
            inset -30px 0 0 rgba(245, 105, 145, 0.4),
            inset 0 -30px 0 rgba(209, 242, 165, 0.4);
    }
    100% {
        box-shadow: inset 30px 0 0 rgba(209, 242, 165, 0.4),
            inset 0 30px 0 rgba(239, 250, 180, 0.4),
            inset -30px 0 0 rgba(255, 196, 140, 0.4),
            inset 0 -30px 0 rgba(245, 105, 145, 0.4);
    }
}
@keyframes colordancing {
    0% {
        color: #d1f2a5;
    }
    25% {
        color: #f56991;
    }
    50% {
        color: #ffc48c;
    }
    75% {
        color: #effab4;
    }
    100% {
        color: #d1f2a5;
    }
}
@keyframes colordancing2 {
    0% {
        color: #ffc48c;
    }
    25% {
        color: #effab4;
    }
    50% {
        color: #d1f2a5;
    }
    75% {
        color: #f56991;
    }
    100% {
        color: #ffc48c;
    }
}

/* demo stuff */
* {
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
}
body {
    background-color: #416475;
    margin-bottom: 50px;
}
html,
button,
input,
select,
textarea {
    font-family: 'Montserrat', Helvetica, sans-serif;
    color: #92a4ad;
}
h1 {
    text-align: center;
    margin: 30px 15px;
    color: #92a4ad;
}
.zoom-area {
    max-width: 490px;
    margin: 30px auto 30px;
    font-size: 19px;
    text-align: center;
    color: #92a4ad;
    color: #92a4ad;
}
.link-container {
    text-align: center;
    display: flex;
    justify-content: center;
    gap: 20px;
}
a.more-link {
    text-transform: uppercase;
    font-size: 13px;
    background-color: #92a4ad;
    padding: 10px 15px;
    border-radius: 0;
    color: #416475;
    display: inline-block;
    margin-right: 5px;
    margin-bottom: 5px;
    line-height: 1.5;
    text-decoration: none;
    margin-top: 50px;
    letter-spacing: 1px;
    width: 330px;
}
</style>
